import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          {contactData.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10">
          {contactData.subtitle}
        </p>

        {contactData.items.map((item) => (
          <div
            key={item.title}
            className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60"
          >
            <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
              <i className={`${item.icon} text-2xl text-primary-600`}></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">
              {item.title}
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-lg mx-auto mb-6">
              {item.desc}
            </p>
            <a
              href={item.actionHref}
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {item.actionLabel}
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}